/**
 * wire-paywall entry. Owns the gate, the walls, and the sealed
 * dispatch path. App calls the presenters through window.__wire.
 */

import { closeModal, presentSealed, presentSignup, presentWall, readerState, markSignedUp } from "./gate";
import { keyMaterial, openSeal, sealDigest, tryOpenSealed, unseal, verify } from "./open-sealed";
import { TIER_TABLE, advance, flowComplete, newFlow, priceLabel } from "./subscription-flow";
import { LAST_DESK, WIRE_BUILD_CHANNEL } from "./wire-internal-notes";
import { allDispatches, archiveStats, currentEditionListed, dispatchesFor, largestSealed, stillSealedCount } from "./sealed-archive";

export const paywall = {
  gate: { readerState, markSignedUp, presentSignup, presentWall, presentSealed, closeModal },
  seal: { openSeal, tryOpenSealed, keyMaterial, sealDigest, verify, unseal },
  tiers: { TIER_TABLE, newFlow, advance, flowComplete, priceLabel },
  archive: { allDispatches, dispatchesFor, stillSealedCount, archiveStats, largestSealed, currentEditionListed },
  build: { channel: WIRE_BUILD_CHANNEL, lastDesk: LAST_DESK },
};

declare global {
  interface Window {
    __wire?: {
      paywall?: typeof paywall;
    };
  }
}

if (typeof window !== "undefined") {
  window.__wire = window.__wire || {};
  window.__wire.paywall = paywall;
}
